import { createSelector } from '@reduxjs/toolkit'

import { makeFetchSelectors } from 'app/redux-fetch/selectors'
import {
  DOMAIN_USERS_LIST_REDUCER_NAME,
  TEAM_REDUCER_NAME,
} from 'features/team/consts'
import type { DomainUser, MappedDomainUser } from './types'

export const domainWithUsersSelector = makeFetchSelectors(
  TEAM_REDUCER_NAME,
  DOMAIN_USERS_LIST_REDUCER_NAME
)

export const domainUsersListSelector = createSelector(
  domainWithUsersSelector?.data,
  (domainWithUsers) => {
    const users = (domainWithUsers?.[0]?.users || []) as DomainUser[]

    return users.map((user) => ({
      id: user.id,
      name: `${user.lastName}, ${user.firstName}`,
      email: user.email,
      avatar: user.profilePicUrl,
      isAdmin: user.domainPermissionUser && user.domainPermissionDomain,
      isConfigAuthor: user.configAuthor,
      domainId: user.domainId,
      isSubscriptionManager: user.purchase,
    })) as MappedDomainUser[]
  }
)
